import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navigation" }
const _hoisted_2 = { class: "nav-infos" }
const _hoisted_3 = { class: "nav-search__kbd" }
const _hoisted_4 = ["aria-label"]

import { RouterLink } from 'vue-router';
import { useCommandPalette } from '../composables/useCommandPalette';
import { useTheme } from '../composables/useTheme';
import { BaseNavigationMenu, BaseSeparator } from '@tommaniglier/design-system-lib/vue';
import type { NavigationMenuItem } from '@tommaniglier/design-system-lib/vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Navigation',
  setup(__props) {

const { openPalette } = useCommandPalette();
const { theme, toggleTheme } = useTheme();

const navItems: NavigationMenuItem[] = [
  { label: 'Home', to: '/' },
  { label: 'Docs', to: '/docs' },
  {
    label: 'Components',
    links: [
      { label: 'Formulaires', description: 'Champs, boutons et contrôles de saisie.', to: '/docs/button' },
      { label: 'Affichage', description: 'Badges, avatars, cartes et indicateurs visuels.', to: '/docs/badge' },
      { label: 'Feedback', description: 'Alertes, tooltips et boîtes de dialogue.', to: '/docs/alert' },
      { label: 'Navigation', description: "Onglets, menus, fil d'ariane et pagination.", to: '/docs/tabs' },
      { label: 'Données', description: 'Tableaux, graphiques et sélecteurs de date.', to: '/docs/table' },
      { label: 'Utilitaires', description: 'Tiroirs, éléments de liste et raccourcis clavier.', to: '/docs/drawer' },
    ],
  },
  { label: 'Patterns', to: '/patterns' },
  { label: 'Motion Lab', to: '/motion-lab' },
  { label: 'Agents', to: '/agents' },
];

const isMac =
  typeof navigator !== 'undefined' &&
  /Mac|iPhone|iPad|iPod/.test(navigator.platform || navigator.userAgent);
const kbdLabel = isMac ? '⌘ K' : 'Ctrl K';

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(_unref(BaseNavigationMenu), {
      items: navItems,
      "link-component": _unref(RouterLink)
    }, null, 8 /* PROPS */, ["link-component"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "nav-search",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(openPalette) && _unref(openPalette)(...args)))
      }, [
        _cache[2] || (_cache[2] = _createElementVNode("svg", {
          class: "nav-search__icon",
          viewBox: "0 0 24 24",
          width: "16",
          height: "16",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "aria-hidden": "true"
        }, [
          _createElementVNode("circle", {
            cx: "11",
            cy: "11",
            r: "8"
          }),
          _createElementVNode("path", { d: "m21 21-4.3-4.3" })
        ], -1 /* CACHED */)),
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "nav-search__label" }, "Search...", -1 /* CACHED */)),
        _createElementVNode("kbd", _hoisted_3, _toDisplayString(_unref(kbdLabel)), 1 /* TEXT */)
      ]),
      _createVNode(_unref(BaseSeparator), { orientation: "vertical" }),
      _createElementVNode("button", {
        type: "button",
        class: "dark-light",
        "aria-label": _unref(theme) === 'dark' ? 'Passer en thème clair' : 'Passer en thème sombre',
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(toggleTheme) && _unref(toggleTheme)(...args)))
      }, [...(_cache[4] || (_cache[4] = [
        _createStaticVNode("<svg class=\"dark-light__icon dark-light__icon--sun\" viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\" data-v-4f231a80><circle cx=\"12\" cy=\"12\" r=\"4\" data-v-4f231a80></circle><path d=\"M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41\" data-v-4f231a80></path></svg><svg class=\"dark-light__icon dark-light__icon--moon\" viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\" data-v-4f231a80><path d=\"M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z\" data-v-4f231a80></path></svg>", 2)
      ]))], 8 /* PROPS */, _hoisted_4)
    ])
  ]))
}
}

})